import { render, staticRenderFns } from "./PageStart.vue?vue&type=template&id=36f038bf"
import script from "./PageStart.vue?vue&type=script&lang=js"
export * from "./PageStart.vue?vue&type=script&lang=js"
import style0 from "./PageStart.vue?vue&type=style&index=0&id=36f038bf&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports